import React, { useEffect } from 'react';
import Layout from './Layout';
import { useHistory, useLocation, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../CustomComponents/Spinner';
import Dashboard from './Dashboard';
import Doctors from './Doctors';
import Settings from './Settings';
import Reviewers from './Reviewers';
import ProfileInformation from './Settings/Profile';
import { AddUser, ClearUser } from '../../Redux/Actions/User';
import { UserApi } from '../../Apis/User';
// import Transcriptionists from './Transcriptionists';
import NotesBoardPage from './NotesBoardPage';
import JobList from './JobList';
import Editor from './Editor';
import EhrConfiguration from './Settings/EhrConfiguration';
import HL7 from './Hl7';
// import Payment from './Billing/Payment';
// import Billing from './Billing';
// import Subscription from './Billing/Subscription';
// import PaymentLog from './Billing/PaymentLog';
import { disconnectSocket } from '../../Socket';
import { useIdleTimer } from 'react-idle-timer';
import { IDLE_LOGOUT_TIME_MINUTES } from '../../Constants/StringConstants';
import Audit from './Audit';
import { logoutAPI } from '../../Apis/Auth';
import Admins from './Admins';
import Biller from './Biller';
import Billers from './Billers';
// import DeviceConfiguration from './Settings/DeviceConfiguration';
import KeyToPhrase from './KeyToPhrase';
import Dictation from './Dictation';
import TemplateList from './TemplateList';
import VeriyfEmr from './VerifyEmr';
import Facility from './Facility';
import NewEditor from './NewEditor';
import NewDashboard from './NewDashboard';
import BillersJobs from './BillersJobs';
import Roster from './Roster';
import Dictionary from './Dictionary';
import BillerAudit from './BillerAudit';
import BillingAdmin from './BillingAdmin';
import DictionaryTemplates from './DictionaryTemplates';
import DictionaryFacility from './DictionaryFacility';
import DictionaryFacilityConfiguration from './DictionaryFacility/DictionaryFacilityConfiguration';
import UsersPage from './UsersPage';
import UserManagement from './UserManagement';
import UserAuditLogs from './UserManagement/UserAuditLogs';
import AuditLogs from './AuditLogs';
import MipsManagement from './MipsManagement';
import NTAPage from './NTAPage';
import ClinicSettings from './ClinicSettings';
import CopyK2P from './CopyK2P';
const SCRIBE_ALLOWED_PATHS = [
  '/dashboard/jobs-list',
  '/dashboard/new-editor',
  '/dashboard/settings/profile'
];

const Content = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const userState = useSelector(state => state.userReducer);

  useEffect(() => {
    const user = localStorage.getItem('user');
    const loggedIn = localStorage.getItem('loggedIn');
    if (!user && !loggedIn) {
      history.push('/login');
    } else {
      const parsedUser = JSON.parse(user);
      dispatch(AddUser(parsedUser));

      // Load the user's date/time format preference on app start so every
      // displayed date/time (read from localStorage) follows it app-wide.
      if (parsedUser?.id) {
        UserApi(parsedUser.id)
          .then(response => {
            const dateTimeConfig =
              response?.data?.result?.[0]?.dateTimeConfig;
            if (dateTimeConfig) {
              const updatedUser = { ...parsedUser, dateTimeConfig };
              dispatch(AddUser(updatedUser));
              localStorage.setItem('user', JSON.stringify(updatedUser));
            }
          })
          .catch(() => {});
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.userType === 'scribe') {
      const isAllowed = SCRIBE_ALLOWED_PATHS.some(path =>
        location.pathname.startsWith(path)
      );
      if (!isAllowed) {
        history.replace('/dashboard/jobs-list/my-jobs/in-progress');
      }
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleOnIdle = event => {
    getLastActiveTime();
    logout();
  };

  const { getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * IDLE_LOGOUT_TIME_MINUTES,
    onIdle: handleOnIdle,
    debounce: 500
  });

  const logout = () => {
    logoutAPI(userState.sessionId).then(resp => {
      disconnectSocket();
      dispatch(ClearUser());
      localStorage.clear();
      sessionStorage.clear();
      history.push('/login');
    });
  };

  return userState.id ? (
    <Layout>
      <Route
        exact
        path='/'
        // component={userState.superAdmin ? NewDashboard : Dashboard}
        component={Dashboard}
      />
      <Route
        exact
        path='/dashboard'
        // component={userState.superAdmin ? NewDashboard : Dashboard}
        component={Dashboard}
      />
      <Route exact path='/dashboard/admins' component={Admins} />
      <Route path='/dashboard/billing-admin' component={BillingAdmin} />
      <Route path='/dashboard/biller' component={Biller} />
      <Route path='/dashboard/doctors' component={Doctors} />
      <Route path='/dashboard/reviewers' component={Reviewers} />
      <Route path='/dashboard/billers' component={Billers} />
      <Route path='/dashboard/roster' component={Roster} />
      <Route path='/dashboard/UsersPage' component={UsersPage} />
      {/* <Route
        path='/dashboard/transcriptionists'
        component={Transcriptionists}
      />  */}
      <Route exact path='/dashboard/settings' component={Settings} />
      <Route
        path='/dashboard/settings/profile'
        component={ProfileInformation}
      />
      <Route exact path='/dashboard/dictionary' component={Dictionary} />
      <Route
        exact
        path='/dashboard/user-management/:userId/logs'
        component={UserAuditLogs}
      />
      <Route
        exact
        path='/dashboard/user-management'
        component={UserManagement}
      />
      <Route exact path='/dashboard/audit-logs' component={AuditLogs} />
      <Route
        exact
        path='/dashboard/dictionary-templates'
        component={DictionaryTemplates}
      />
      <Route
        exact
        path='/dashboard/dictionary-facility'
        component={DictionaryFacility}
      />
      <Route
        exact
        path='/dashboard/dictionary-facility/:facilityId'
        component={DictionaryFacilityConfiguration}
      />
      <Route
        exact
        path='/dashboard/facility-management'
        component={DictionaryFacility}
      />
      <Route
        exact
        path='/dashboard/facility-management/:facilityId/:tab?'
        component={DictionaryFacilityConfiguration}
      />
      <Route exact path='/dashboard/mips-management' component={MipsManagement} />
      <Route exact path='/dashboard/nta' component={NTAPage} />
      <Route exact path='/dashboard/copy-k2p' component={CopyK2P} />
      <Route path='/dashboard/biller-audit' component={BillerAudit} />
      <Route path='/dashboard/hl7' component={HL7} />
      <Route
        path='/dashboard/settings/ehr-configuration'
        component={EhrConfiguration}
      />
      {/* <Route
        path='/dashboard/settings/device-configuration'
        component={DeviceConfiguration}
      /> */}
      <Route path='/dashboard/jobs-list' component={JobList} />
      <Route path='/dashboard/editor/:jobId' component={Editor} />
      <Route path='/dashboard/new-editor/:jobId' component={NewEditor} />
      <Route
        exact
        path='/dashboard/billers-jobs/:jobId'
        component={BillersJobs}
      />
      <Route exact path='/dashboard/notes-board' component={NotesBoardPage} />
      {/* <Route exact path='/dashboard/billing' component={Billing} /> */}
      {/* <Route path='/dashboard/billing/manage-cards' component={Payment} /> */}
      {/* <Route path='/dashboard/billing/payment-logs' component={PaymentLog} /> */}
      {/* <Route
        path='/dashboard/billing/manage-subscription'
        component={Subscription}
      /> */}
      <Route exact path='/dashboard/audit' component={Audit} />
      <Route
        exact
        path='/dashboard/settings/key-to-phrase'
        component={KeyToPhrase}
      />
      <Route exact path='/dashboard/settings/dictation' component={Dictation} />
      <Route exact path='/dashboard/settings/template-list' component={TemplateList} />
      <Route
        path='/dashboard/verify-emr/:clinicId/user/:userId'
        component={VeriyfEmr}
      />
      <Route exact path='/dashboard/settings/facility' component={Facility} />
      <Route
        exact
        path='/dashboard/settings/clinic-settings'
        component={ClinicSettings}
      />
      <Route
        exact
        path='/dashboard/facility/:facilityId'
        component={EhrConfiguration}
      />
    </Layout>
  ) : (
    <Spinner height={'100vh'} />
  );
};
export default Content;
